import uniq from "lodash-es/uniq";
import { Reducer } from "redux";

import { tupdate } from "@/mk2/helpers/types";
import infiniteList, {
    State as InfiniteListState,
    initialState as infiniteInitialState,
} from "@/mk2/reducers/infiniteList";

import {
    COMMON_PLACE_TOPICS_FETCH_FAILURE,
    COMMON_PLACE_TOPICS_FETCH_REQUEST,
    COMMON_PLACE_TOPICS_FETCH_SUCCESS,
    COMMON_PLACE_TOPICS_UPDATE_SEARCH,
    CommonPlaceTopicsFetchFailureAction,
    CommonPlaceTopicsFetchRequestAction,
    CommonPlaceTopicsFetchSuccessAction,
    CommonPlaceTopicsUpdateSearchAction,
} from "./CommonPlaceTopics.actions";

export interface SearchState extends InfiniteListState {
    followingIds: number[];
}

type SearchReducerAction =
    | CommonPlaceTopicsFetchRequestAction
    | CommonPlaceTopicsFetchSuccessAction
    | CommonPlaceTopicsFetchFailureAction;

export const initialSearchState: SearchState = {
    ...infiniteInitialState,
    followingIds: [],
};

const searchReducer: Reducer<SearchState, SearchReducerAction> = (
    state = initialSearchState,
    action,
) => {
    const newState: SearchState = {
        ...state,
        ...infiniteList<
            CommonPlaceTopicsFetchRequestAction,
            CommonPlaceTopicsFetchSuccessAction,
            CommonPlaceTopicsFetchFailureAction
        >("COMMON_PLACE_TOPICS_FETCH", (a) => a.response.result.topics)(state, action),
    };

    switch (action.type) {
        case COMMON_PLACE_TOPICS_FETCH_SUCCESS:
            newState.followingIds = uniq(action.response.result.followingTopics);
            break;
    }

    return newState;
};

interface SearchesState {
    [search: string]: SearchState;
}

type CategoryReducerAction =
    | CommonPlaceTopicsFetchRequestAction
    | CommonPlaceTopicsFetchSuccessAction
    | CommonPlaceTopicsFetchFailureAction;

const searchesReducer: Reducer<SearchesState, CategoryReducerAction> = (state = {}, action) => {
    switch (action.type) {
        case COMMON_PLACE_TOPICS_FETCH_REQUEST:
        case COMMON_PLACE_TOPICS_FETCH_SUCCESS:
        case COMMON_PLACE_TOPICS_FETCH_FAILURE: {
            const search = action.search;
            return tupdate(state, {
                [search]: searchReducer(state[search], action),
            });
        }
        default:
            return state;
    }
};

interface TypesState {
    [type: string]: SearchesState;
}

type TypesReducerAction =
    | CommonPlaceTopicsFetchRequestAction
    | CommonPlaceTopicsFetchSuccessAction
    | CommonPlaceTopicsFetchFailureAction;

const typesReducer: Reducer<TypesState, TypesReducerAction> = (state = {}, action) => {
    switch (action.type) {
        case COMMON_PLACE_TOPICS_FETCH_REQUEST:
        case COMMON_PLACE_TOPICS_FETCH_SUCCESS:
        case COMMON_PLACE_TOPICS_FETCH_FAILURE: {
            const placeType = action.placeType;
            return tupdate(state, {
                [placeType]: searchesReducer(state[placeType], action),
            });
        }
        default:
            return state;
    }
};

export interface CommonPlaceTopicsPageState {
    types: TypesState;
    search: string;
}

export const initialCommonPlaceTopicsPageState: CommonPlaceTopicsPageState = {
    types: {},
    search: "",
};

type CommonPlaceTopicsPageReducerAction =
    | CommonPlaceTopicsFetchRequestAction
    | CommonPlaceTopicsFetchSuccessAction
    | CommonPlaceTopicsFetchFailureAction
    | CommonPlaceTopicsUpdateSearchAction;

const commonPlaceTopicsPageReducer: Reducer<
    CommonPlaceTopicsPageState,
    CommonPlaceTopicsPageReducerAction
> = (state = initialCommonPlaceTopicsPageState, action) => {
    switch (action.type) {
        case COMMON_PLACE_TOPICS_FETCH_REQUEST:
        case COMMON_PLACE_TOPICS_FETCH_SUCCESS:
        case COMMON_PLACE_TOPICS_FETCH_FAILURE:
            return tupdate(state, {
                types: typesReducer(state.types, action),
            });
        case COMMON_PLACE_TOPICS_UPDATE_SEARCH:
            return tupdate(state, {
                search: action.search,
            });
        default:
            return state;
    }
};

export default commonPlaceTopicsPageReducer;
